import axios from "..";
import { IEntityBase } from "../../types";

export const createNewEntity = (entity: IEntityBase[]): Promise<void> => {
  return axios.put("/schema-batch", entity);
};
